import { render, staticRenderFns } from "./CenteredImage.vue?vue&type=template&id=44f5ab2d&scoped=true&"
import script from "./CenteredImage.vue?vue&type=script&lang=js&"
export * from "./CenteredImage.vue?vue&type=script&lang=js&"
import style0 from "./CenteredImage.vue?vue&type=style&index=0&id=44f5ab2d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f5ab2d",
  null
  
)

export default component.exports